export const PIN_COLORS: string[] = [
  '#81A7F2',
  '#59BCC7',
  '#8DCB27',
  '#F06A6F',
  '#FFAF61',
  '#9DBA6E',
  '#66AAC7',
  '#A75F61',
  '#81A7F2',
  '#59BCC7',
  '#8DCB27',
  '#F06A6F',
  '#FFAF61',
  '#9DBA6E',
  '#66AAC7',
  '#A75F61',
  '#81A7F2',
  '#59BCC7',
  '#8DCB27',
  '#F06A6F',
  '#FFAF61',
  '#9DBA6E',
  '#66AAC7',
  '#A75F61',
];

export const PIN_OS_COLOR = '#262626BF';
export const PIN_APP_OS_COLOR = '#626264';

export const PIN_ALPHABET =
  'ABCDEFGHIJKLMNOPQESTUVWXYZabcdefghijklmnopqestuvwxyz1234567890';
